module.exports = __webpack_public_path__ + "img/people.aaa1b0f1.svg";